import { render, staticRenderFns } from "./InvestigationRegister.vue?vue&type=template&id=ab32687e&scoped=true&"
import script from "./InvestigationRegister.vue?vue&type=script&lang=js&"
export * from "./InvestigationRegister.vue?vue&type=script&lang=js&"
import style0 from "./InvestigationRegister.vue?vue&type=style&index=0&id=ab32687e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab32687e",
  null
  
)

export default component.exports